module.exports = __webpack_public_path__ + "img/mapa_seda_en.9f0a7c2a.png";